<template>
    <router-link :to="route" :class="{'bg-light-gray': $route.path === route}" class="flex items-center justify-between h3  ph3 link pointer black  bb b--light-gray  hover-bg-near-white">
        <div class="th flex items-center">
            <img style="width:20px;" :src="image"/>
            <h6 class="ml3">{{title}}</h6>
        </div>
        <div class="flex items-center">
            <img style="width:10px;" src="@/assets/img/icon_forward_simple_yellow.svg"/>
        </div>
    </router-link>
</template>

<script>
export default {
    props: {
        image: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        route: {
            type: String,
            required: true
        }
    }
};
</script>
